module.exports = __webpack_public_path__ + "img/NDTVPrime1.71fba526.jpg";